import React from 'react';
import { View } from 'react-native';

import Hp from './Hp';
import Body from './Body';

import { PADDING1 } from '../styleConstants';

import { WarriorType } from '../../lib/types';

type Props = {
  warrior: WarriorType;
  showInfo?: boolean;
  onThingInfo?: Function;
  height?: number;
  inCombat?: boolean;
  hideThingOverlay?: boolean;
  applyEnabled?: boolean;
};

const FullBody = ({
  warrior,
  showInfo,
  inCombat,
  onThingInfo,
  height,
  hideThingOverlay,
  applyEnabled,
}: Props) => (
  <View>
    <View>
      <Hp warrior={warrior} inCombat={inCombat} showInfo={showInfo} height={height} />
    </View>
    <View style={{ marginTop: PADDING1 }}>
      <Body
        warrior={warrior}
        onThingInfo={onThingInfo}
        height={height}
        hideThingOverlay={hideThingOverlay}
        applyEnabled={applyEnabled}
      />
    </View>
  </View>
);

export default FullBody;
